import { atom } from "jotai";
import {
  DockerRepositorySelection,
  DockerfileSelection,
} from "@/components/filters";
import { DockerFilters } from "@/components/filters";

export interface CommonFilters {
  selectedBranches: string[];
}

// OrgLevelChartFilters are chart filters for org level analytics.
export interface OrgLevelChartFilters extends CommonFilters {
  selectedRepos: DockerRepositorySelection[];
}

// RepoLevelChartFilters are chart filters for repo level analytics.
export interface RepoLevelChartFilters extends CommonFilters {
  selectedDockerfiles: DockerfileSelection[];
}

export const defaultOrgChartFilters: OrgLevelChartFilters = {
  selectedRepos: [],
  selectedBranches: [],
};

export const defaultRepoChartFilters: RepoLevelChartFilters = {
  selectedDockerfiles: [],
  selectedBranches: [],
};

export const dockerOrgChartFiltersAtom = atom(defaultOrgChartFilters);
export const dockerRepoChartFiltersAtom = atom(defaultRepoChartFilters);

export const dockerOrgTableFiltersAtom = atom<DockerFilters>({});
export const dockerRepoTableFiltersAtom = atom<DockerFilters>({});
